import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/transport/peccancyrecord/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/transport/peccancyrecord/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/transport/peccancyrecord/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/transport/peccancyrecord/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const clientSearchByName = (params, urlParams) => {
  return axios.request({
    url: '/transport/peccancyrecord/clientsearchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const clientGetPage = (params, urlParams) => {
  return axios.request({
    url: '/transport/peccancyrecord/clientgetpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const analyzeSingle = (params, urlParams) => {
  return axios.request({
    url: '/transport/peccancyrecord/analyzesingle/' + params.transportVehicleInfoId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const analyzeAll = (params, urlParams) => {
  return axios.request({
    url: '/transport/peccancyrecord/analyzeall' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

